<template>
    <div class="download">
        <title-screen title="24"></title-screen>
        <el-row style="text-align: center" v-if="loading">
            <img alt="loading" src="@/assets/images/loading.gif">
        </el-row>
        <el-row v-else-if="documents.length > 0">
            <div :key="document.categoryId"
                 ref="docs"
                 v-for="document in documents">
                <div class="table-document">
                    <div class="category">
                        {{document.categoryName}}
                    </div>
                    <div class="list-file" v-if="document.customerDocuments && document.customerDocuments.length > 0">
                        <div :key="file.customerDocumentId" class="file-container"
                             v-for="file in document.customerDocuments">
                            <div class="file">
                                <div class="thumbnail-wrapper">
                                  <img :src="file.thumbnailSingedUrl || require('@/assets/images/PDF.png')" alt=""
                                    class="thumbnail"/>
                                </div>
                                <div class="name">
                                    {{file.documentName}}
                                </div>
                                <document-summary :summary="file.documentSummary"></document-summary>
                                <div class="btn">
                                    <el-button @click="download(file)" class="btn button-color" type="danger">ダウンロード
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="empty-category" v-text="emptyCategoryText" v-else>
                    </div>
                </div>
            </div>
        </el-row>
    </div>
</template>
<script>
  import TitleScreen from '../../../../components/common/TitleScreen'
  import DocumentSummary from './DocumentSummary'
  import ApiDownload from '@/api/download/download.js'
  import ApiAnken from '@/api/anken/anken-cl.js'
  import { get, isEmpty } from 'lodash'
  import { mapGetters } from 'vuex'

  export default {
    components: { TitleScreen, DocumentSummary },
    data () {
      return {
        documents: [],
        loading: false,
        width: 0,
        listCharacterMax: [],
        hasAnken: false
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'isAuthenticated']),
      emptyCategoryText () {
        if (!this.isAuthenticated) {
          return '相続のせんせい会員様限定資料になります'
        } else if (!this.hasAnken) {
          return 'レガシィへご依頼いただいたお客様向け限定資料になります'
        } else {
          return '近日公開予定'
        }
      }
    },
    created () {
      window.addEventListener('resize', this.computeWidthAndHeight)
      if (this.isAuthenticated) {
        ApiAnken.getAnkenList().then(response => {
          let ankens = response.data
          if (ankens.length > 0) {
            this.hasAnken = true
          } else {
            this.hasAnken = false
          }
        })
      }
    },
    mounted () {
      this.getListDocuments()
    },
    methods: {
      computeWidthAndHeight () {
        if (this.$refs.docs) {
          let listDocs = [].concat(this.$refs.docs)
          listDocs.forEach(doc => {
            doc.querySelectorAll('.name').forEach(item => {
              item.style.height = ''
            })
            let files = doc.querySelectorAll('.file')
            if (isEmpty(files)) return
            let maxHeightName = 0
            files.forEach(file => {
              let name = file.querySelector('.name')
              if (maxHeightName < name.clientHeight) {
                maxHeightName = name.clientHeight
              }
            })
            files.forEach(file => {
              file.querySelector('.name').style.height = maxHeightName + 'px'
            })
            files.forEach(file => {
              if (window.innerWidth > 1024) {
                const fileContainer = file.parentElement
                if (fileContainer.clientWidth < (doc.clientWidth / 4)) {
                  file.style.width = '100%'
                } else if (fileContainer.clientWidth < (doc.clientWidth / 3)) {
                  file.style.width = '75%'
                } else if (fileContainer.clientWidth < (doc.clientWidth / 2)) {
                  file.style.width = '50%'
                } else {
                  file.style.width = '25%'
                }
              } else {
                file.style.width = '100%'
              }
            })
          })
        }
      },
      async getListDocuments () {
        try {
          this.loading = true
          let res = await ApiDownload.getListDownloadDocument()
          let temp = res.data
          if (!isEmpty(temp)) {
            this.documents = temp
          }
        } catch (e) {
        } finally {
          this.loading = false
          this.$nextTick(() => {
            this.computeWidthAndHeight()
          })
        }
      },
      download (item) {
        ApiDownload.downloadDocument(item.customerDocumentId).then(res => {
          let url = get(res, 'data.signedUrl')
          if (url) {
            fetch(url)
              .then(response => response.blob())
              .then(blob => {
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = item.documentName + '.pdf'
                link.click()
              })
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
    .table-document {
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-bottom: 25px;

        .category {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            background-color: #fbe6b3;
            border: 2px solid #c5a003;
            border-bottom: 0;
            padding: 10px;
            font-weight: 700;
        }

        .list-file {
            display: flex;
            flex-wrap: wrap;
            background-color: #fdf4db;
            border: 2px solid #c5a003;
            border-left: 0;
            border-top: 0;

            .file-container {
                background-color: #fdf4db;
                border: 2px solid #c5a003;
                border-bottom: 0;
                border-right: 0;
                padding: 10px;
                min-width: 25%;
                flex: 1 0;

                .file {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;
                    height: 100%;
                    margin: auto;

                    .thumbnail-wrapper {
                        height: 158px;
                        width: 100%;
                        position: relative;

                        .thumbnail {
                          max-height: 100%;
                          max-width: 100%;
                          position: absolute;
                          top: 0;
                          bottom: 0;
                          left: 0;
                          right: 0;
                          margin: auto;
                        }
                    }

                    .name {
                        padding: 15px 0;
                        font-weight: 700;
                        width: 100%;
                        text-align: center;
                        font-size: 16px;
                    }
              }
            }
        }

        .empty-category {
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fdf4db;
            border: 2px solid #c5a003;
            padding: 10px;
        }
    }

    @media screen and (max-width: 1024px) and (min-width: 513px) {
        .file-container {
            min-width: 50% !important;
        }
    }

    @media screen and (max-width: 512px) {
        .file-container {
            min-width: 100% !important;
        }
    }
</style>
